import styled, { css } from 'styled-components';

export const StatusColorSelectOptionStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ColorIconStyled = styled.div<{ color?: string }>`
  height: 24px;
  width: 24px;
  border-radius: 3px;
  ${({ color }) => {
    return css`
      background-color: ${color};
    `;
  }}
`;
